<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.PackageCode }}</td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.PartnerCode"
                    lazy
                    @save="saveItem({ID: item.ID, PartnerCode: item.PartnerCode})"
                  >
                    <div>{{ item.PartnerCode }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.PartnerCode"
                        label="Mã trung chuyển"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                <td class="text-right">{{ item.ImportPackage | currency }}</td>
                <td class="text-right">{{ item.ImportWeight | currency('', 1) }}</td>
                <td class="text-right">{{ item.ImportVolume | currency('', 2) }}</td>
                <td class="text-right">{{ item.FeeShipCNY | currency('', 1) }}</td>                
                <td v-if="userRole===1">
                  <v-edit-dialog :return-value.sync="item.Status" large lazy persistent @save="saveItem({ID: item.ID, Action: 'update_status', Status: item.Status})">
                    <div v-bind:style="{ 'color': get_status_color(item.Status, status_list)}">{{ item.Status | display_value(status_list) }}</div>
                    <template v-slot:input>
                        <v-select v-model="item.Status" :items="status_list" item-text="name" item-value="value" label="Trạng thái" single-line autofocus></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-else v-bind:style="{ 'color': get_status_color(item.Status, status_list)}">{{ item.Status | display_value(status_list) }}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td v-if="userRole !== 0">{{ item.CreatedBy }}</td>
                <td class="text-center" v-if="userRole === 0">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">visibility</v-icon>
                </td>
                <td class="text-center" v-if="userRole !== 0">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">edit</v-icon>
                  <v-icon medium class="mr-2" color="red darken-2" @click="printLabel(item.PackageCode, item.Weight, item.Volume)">print</v-icon>
                  <v-icon v-if="userRole===1" medium @click="deleteItem(item.ID)">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>      
       <big-package-popup
        :dialogPackageDetail="dialogPackageDetail"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></big-package-popup>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import big_package from "@/components/popups/big_package";
import Filtering from "@/components/Filtering";
import { currency } from "@/commons/currency";
import moment from "moment";
import createPermissionMixin from "@/mixins/permissionMixin";
import _ from "lodash";

export default {
  mixins: [createPermissionMixin('big_package')],
  components: {
    "hpo-filter": Filtering,
    "big-package-popup": big_package,
  },
  data() {
    return {
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "bigpackage_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogPackageDetail: false,
      status_list: configs.BIGPACKAGE_STATUS_LIST,
      feeType: configs.FEE_TYPE
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.bigPackage.all.data,
      total_rows: state => state.bigPackage.all.total,
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      let hd = [
        {
          text: "Bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã bốc",
          value: "PartnerCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "KG",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
         {
          text: "M3",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số gói",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Kiện nhập",
          value: "ImportPackage",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Kg nhập",
          value: "ImportWeight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "M3 nhập",
          value: "ImportVolume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship (¥)",
          value: "FeeShipCNY",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.BIGPACKAGE_STATUS_LIST,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        }
      ];
      if(this.userRole !== 0) {
        hd.push({
          text: "Người tạo",
          value: "CreatedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        });
      }
      hd.push({
        text: "Thao tác",
        value: "",
        align: "center",
        sortable: false,
        filterable: false
      });
      return hd;
    }
  },
  methods: {
    printLabel(packageCode, weight, volume) {
      var mywindow = window.open("", "PRINT");

      mywindow.document.write("<html><head><title></title>");
      mywindow.document.write(
        "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
      );
      mywindow.document.write(
        ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
      );
      mywindow.document.write(
        ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
      );
      mywindow.document.write(
        "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
      );
      mywindow.document.write("<div class='layout wrap'>");
      mywindow.document.write(
        `<div class='flex lg12'><p class='title'>${packageCode}</p></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${currency(weight)} kg</p></div></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Số kiện</p></div><div class='flex lg6'><p class='sub-title r-text'>${currency(volume)}</p></div></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
          new Date()
        ).format("DD-MM-YYYY")}</p></div></div>`
      );
      mywindow.document.write(`<hr class='v-divider theme--light'>`);
      mywindow.document.write(
        `<div class='flex lg12'><p class='note-text'>atlogistics.vn transportation & logistics</p></div>`
      );
      mywindow.document.write("</div>");
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      mywindow.print();
      return true;
    },
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bigPackage/getList", param);
    },
    gotoDetail: function(id) {
      let configPaging = _.cloneDeep(configs.PAGINATION);
      configPaging.itemsPerPage = 5;
      var param = {
         pagination: {
            ...configPaging,
            itemsPerPage: 1000000
          }
      };
      
      this.$store.dispatch("bigPackage/getDetail", {'id': id, 'param': param});
      setTimeout(() => {this.dialogPackageDetail = true}, 200);
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.commit("bigPackage/setDetail", {
        'data': {
          ID: 0,
          PackageCode: '',
          ReceivePlaceID: 1,
          Weight: 0,
          Volume: 0,
          FeeShipVND: 0,
          FeeShipCNY: 0,
          Amount: 0,
          Status: 0,
          FeeType: 0,
          Packages: []
        },
        'param': param
      });
      this.dialogPackageDetail = true;
    },
    saveItem(item) {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bigPackage/setDetail", {
        'data': item,
        'id': item.ID,
        'param': param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
  },
  mounted() {
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bigPackage/removeDetail", id);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
